/**
 * Params and search for a link to a unit: spread onto
 * `<Link to="/groups/$shortName">`.
 *
 * A sub-unit has no page of its own: its address is its parent's page narrowed
 * to it, /groups/administration?unit=grants.
 */
export function groupLink(unit: { slug: string; parentSlug: string | null }) {
  return unit.parentSlug === null
    ? { params: { shortName: unit.slug }, search: {} }
    : { params: { shortName: unit.parentSlug }, search: { unit: unit.slug } };
}
